/* Collection "Sort by": difficulty only (2026-10-24).
   Shopify has no difficulty sort, so the grid is reordered here using window.tosDifficulty
   (handle -> product metafield custom.difficulty, printed by sections/tos-fixes.liquid).
   Products without a difficulty keep their order and go last. */
(function () {
  var RANK = { Easy: 1, Medium: 2, Hard: 3, Expert: 4 };
  var OPTIONS = [
    ['difficulty-ascending', 'Difficulty, easy to hard'],
    ['difficulty-descending', 'Difficulty, hard to easy']
  ];

  function difficulty(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m && (window.tosDifficulty || {})[decodeURIComponent(m[1])];
  }

  function current() {
    var v = new URLSearchParams(location.search).get('sort_by');
    return v === 'difficulty-descending' ? v : 'difficulty-ascending';
  }

  function fixSelects() {
    var want = current();
    document.querySelectorAll('select[name="sort_by"]').forEach(function (sel) {
      if (sel.dataset.tosSort === want && sel.options.length === OPTIONS.length) return;
      sel.innerHTML = '';
      OPTIONS.forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o[0];
        opt.textContent = o[1];
        if (o[0] === want) opt.selected = true;
        sel.appendChild(opt);
      });
      sel.dataset.tosSort = want;
    });
  }

  function sortGrid() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var dir = current() === 'difficulty-descending' ? -1 : 1;
    var items = Array.prototype.slice.call(grid.children).filter(function (li) { return li.matches('li'); });
    items.forEach(function (li, i) { if (li.dataset.tosIndex == null) li.dataset.tosIndex = i; });
    var sorted = items.slice().sort(function (a, b) {
      var ra = RANK[difficulty(a)], rb = RANK[difficulty(b)];
      if (ra && rb && ra !== rb) return (ra - rb) * dir;
      if (ra && !rb) return -1;
      if (rb && !ra) return 1;
      return a.dataset.tosIndex - b.dataset.tosIndex;
    });
    if (sorted.every(function (li, i) { return li === items[i]; })) return;
    sorted.forEach(function (li) { grid.appendChild(li); });
  }

  function run() { fixSelects(); sortGrid(); }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', schedule);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
